import axiosApi from '../../apis/axiosApi';
import {
	getConvertResult,
	getSceneObjects,
	saveCampaignData,
	saveTemp,
	submitForConversion,
} from '@wsc/apis/webStoreAPI';
import { formURL } from '@wsc/utils/apiUtils';
import {
	getFilename,
	getFileExtension,
	getFilenameWithExtension,
	getMimePrimaryType,
	checkIsImageAsset,
	checkIsAudioAsset,
	checkIsVideoAsset,
	checkIs3DModelAsset,
	checkIsLottieAsset,
} from '@wsc/utils/fileUtils';
import { findKeyRecursivelyInObject } from '@wsc/utils/functionUtils';
import useTranslate from '../../hooks/useTranslate';
import useLocalize from '../../hooks/useLocalize';
import useLocalizedNavigation from '../../hooks/useLocalizedNavigation';
import useAnalytics from '../../hooks/useAnalytics';
import usePathChange from '../../hooks/usePathChange';
import useLookAt from '../../hooks/useLookAt';
import { setUIVisibility } from '../../utils/UIComponentUtils';
import InSceneComponentsLoader from '../../components/loaders/InSceneComponentsLoader';
import { getHotspotLink } from '@wsc/utils/urlHelpers';
import { createAction, createSlice } from '@reduxjs/toolkit';
import { deprecationWarning } from '@wsc/utils/consoleHelpers';
import useXR from '../../hooks/useXR';
import config from 'config';

const initialState = {
	axios: axiosApi,
	getSceneObjects,
	formURL,
	getFilename,
	getFileExtension,
	getFilenameWithExtension,
	getMimePrimaryType,
	checkIsImageAsset,
	checkIsAudioAsset,
	checkIsVideoAsset,
	checkIs3DModelAsset,
	checkIsLottieAsset,
	useTranslate,
	useLocalize,
	useLocalizedNavigation,
	useAnalytics,
	usePathChange,
	ToolTipLoader: InSceneComponentsLoader,
	useLookAt,
	getHotspotLink,
	saveTemp,
	findKeyRecursivelyInObject,
	setUIVisibility,
	saveCampaignData,
	webStoreApiBaseUrl: config.API_URL,
	submitForConversion,
	getConvertResult,
	useXR,
};

/** DEPRECATED event names do not update */
const SET_FUNCTIONS = 'SET_FUNCTIONS';
const REGISTER_SHAREABLE = 'REGISTER_SHAREABLE';

const slice = createSlice({
	name: 'shareableFunctions',
	initialState,
	reducers: {
		registerShareable: (state, action) => {
			const { payload } = action;
			Object.keys(payload).forEach((key) => {
				state[key] = payload[key];
			});
		},
	},
	extraReducers: (builder) => {
		/** Deprecated reducers, please do not update these, use the ones declared above */
		builder.addCase(createAction(REGISTER_SHAREABLE), (state, action) => {
			const { payload } = action;
			deprecationWarning(
				`'${REGISTER_SHAREABLE}' event is deprecated. Please use 'shareableFunctions/registerShareable' instead. Action structure does not change.`,
			);
			Object.keys(payload).forEach((key) => {
				state[key] = payload[key];
			});
		});

		builder.addCase(createAction(SET_FUNCTIONS), () => {
			deprecationWarning(
				`'${SET_FUNCTIONS}' event is deprecated. Since no usages were found during migration, if you need this event please raise a ticket with Platform team to create a new reducer for this action type.`,
			);
		});
	},
});

export const { registerShareable } = slice.actions;

export default slice.reducer;
